<template>
  <div class="user-page__content">
    <div class="user-card">
      <div class="user-card__info">
        <span v-if="getUserFio" class="user-card__name">{{ getUserFio }}</span>
        <span v-if="addresses && addresses.length" class="user-card__address">
          {{ getFullAddress(addresses[0]) }}
        </span>
      </div>
      <div class="user-card__total">
        <span class="user-card__total-title">Всего покупок на сумму</span>
        <span class="user-card__total-value"> {{ getOrdersSum | formatPrice }} </span>
      </div>
    </div>
    <div class="user-page__orders-sorts">
      <button
        class="btn btn--md"
        type="button"
        v-for="(sort, i) in sortTypes"
        :key="i"
        @click="changeSort(sort)"
        :class="{
          'btn--dark-light': JSON.stringify(activeSort) === JSON.stringify(sort),
          'btn--gray': JSON.stringify(activeSort) !== JSON.stringify(sort),
        }"
      >
        {{ sort.title }}
      </button>
    </div>
    <div class="user-page__orders">
      <table v-if="orders && orders.length" class="table">
        <thead>
          <tr>
            <th>№ Заказа</th>
            <th>Дата заказа</th>
            <th>Сумма заказа</th>
            <th>Баллы</th>
            <th>Состояние</th>
            <th>Действие</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in orders" :key="i">
            <td>{{ item.id }}</td>
            <td>{{ item.created_at | formatDate("DD.MM.YYYY HH:mm") }}</td>
            <td>
              {{ item.sum | formatPrice }}
            </td>
            <td>
              <span v-if="item.bonuses_applied" class="color-red">
                -{{ item.bonuses_applied | formatNumber }}
              </span>
              <span v-if="item.bonuses_applied && item.bonuses_earned">/</span>
              <span v-if="item.bonuses_earned" class="color-green">
                +{{ item.bonuses_earned | formatNumber }}
              </span>
              <span v-if="!item.bonuses_applied && !item.bonuses_earned">-</span>
            </td>
            <td>{{ item.status.name }}</td>
            <td>
              <button type="button" class="order-open-btn" @click="openOrderDetails(item)">Открыть</button>
            </td>
          </tr>
        </tbody>
      </table>
      <span v-else-if="loading">Загрузка заказов...</span>
      <span v-else>Заказы отсутствуют</span>
    </div>
  </div>
</template>

<script>
import OrderDetailsModal from "components/modals/components/OrderDetailsModal.vue";

export default {
  name: "OrdersPage",
  data() {
    return {
      loading: true,
      activeSort: undefined,
      sortTypes: [
        {
          group: undefined,
          title: "Все",
        },
        {
          group: "active",
          title: "Активные",
        },
        {
          group: "canceled",
          title: "Отмененные",
        },
        {
          group: "completed",
          title: "Выполненные",
        },
      ],
    };
  },
  created() {
    this.activeSort = this.sortTypes[0];
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    getUserFio() {
      return [this.user?.surname, this.user?.name, this.user?.patronymic].filter((a) => a).join(" ");
    },
    orders() {
      return this.$store.state.auth.orders;
    },
    addresses() {
      return this.$store.state.auth.addresses;
    },
    getOrdersSum() {
      return this.orders.map((r) => parseInt(r.sum)).reduce((a, b) => a + b, 0);
    },
  },
  methods: {
    getFullAddress(address) {
      return [address.address, address.apartment, address.entrance, address.intercom, address.floor]
        .filter((a) => a)
        .join(", ");
    },
    async changeSort(sort) {
      this.activeSort = sort;
      await this.reload();
    },
    stopLoading() {
      this.loading = false;
    },
    reload() {
      this.$emit("reload", this.$apollo.provider, this.$store, this.$route, {
        status_group: this.activeSort.group,
        page: 1,
      });
    },
    openOrderDetails(order) {
      this.$store.state._modals.push({
        component: OrderDetailsModal,
        options: {
          order: order,
        },
      });
    },
  },
};
</script>

<style lang="stylus">
@import "~@/styles/parts/sorts.styl"
.user-page {
  .user-card {
    display flex
    align-items center
    justify-content space-between
    background: var(--gray_o3)
    border-radius: var(--main_radius)
    padding 15px 20px
    gap 15px
    +below(480px) {
      flex-direction column-reverse
      align-items flex-start
    }

    &__info {
      display flex
      flex-direction column
      gap 2px
    }

    &__name {
      font-weight: 700;
    }

    &__address {
      font-size: 0.875em
      line-height: 145%;
    }

    &__total {
      display flex
      flex-direction column
      align-items flex-end
      flex-shrink 0
			color: var(--main-color)

      &-title {
        font-size: 0.75em
        line-height: 180%;
      }

      &-value {
        font-weight: 700;
        font-size: 2.125em
        line-height: 115%
      }
    }
  }

  &__orders {
    overflow-x auto

    &-sorts {
      display flex
      gap 10px
      overflow-x auto

      .btn {
        flex-shrink 0
      }
    }
  }
}

.order-open-btn {
  background: transparent;
  border: none;
  color: var(--main-color);
  cursor: pointer;
  text-decoration: underline;
  font-size: 1em;
  padding: 0;
  transition: var(--transition);

  &:hover {
    color: var(--main-color-75);
  }
}
</style>
